<template>
	<div class="" style="margin-bottom:5px;border:0px solid var(--grey-5);border-radius: 5px;background:var(--grey-1);">

		<div class="flexcenter header link" style="background:var(--grey-3);padding:10px;position:sticky;top:0px;"
			@click="toggleExpanded()">


			<Circle v-if="currentOrderId == orderId && this.order?.orderStatus?.status == this.orderStatusPreliminary?.status"
				fileName="w3_check_white" color="--bg-warning" padding="20%" title="Vald order"
				style="height:25px;width:25px;margin-right:5px;" />

			<Circle v-if="currentOrderId != orderId && this.order?.orderStatus?.status == this.orderStatusPreliminary?.status"
				fileName="" color="--grey-4" padding="20%" class="link" title="Välj denna order"
				@click.stop="this.orderSelected()" style="height:25px;width:25px;margin-right:5px;" />

			<Circle v-if="this.order?.orderStatus?.status == this.orderStatusSent?.status"
				style="height:25px;width:25px;margin-right:5px;" hover="" fileName="" color="--bg-message" />

			<Circle v-if="this.order?.orderStatus?.status == this.orderStatusRecived?.status"
				style="height:25px;width:25px;margin-right:5px;" hover="" fileName="" color="--bg-ok" />

			<Circle v-if="this.layoutList" :fileName="order.meta.expanded ? 'w3_chevron_up_white' : 'w3_chevron_down_white'"
				style="margin-right:10px;height:25px;width:25px;" color="--grey-6" />


			<div>
				<b class="link">{{ order.orderId }}</b><b v-if="this.order?.localId">, {{
					this.order?.localId }}</b>
				<br />
				<!--span style="color:grey;font-size:80%;" :title="this.order?.orderStatusDate">{{
					this.timeSince(this.order?.orderStatusDate) }} </span -->

				<span v-if="this.order?.orderStatus?.status == 30" style="color:grey;font-size:80%;"
					:title="this.order?.orderStatus?.label + ' ' + this.order?.orderStatus?.date">{{
					this.order?.orderStatus?.timeAgo?.text }} </span>

				<b v-if="this.order?.comment" style="color:grey;font-size:80%;">, {{ this.order?.comment }} </b>

			</div>


			<div v-if=" !this && this.debug">
				E: {{ order.canBeEdited }}, E: {{ order.meta.edited }} date: {{ order.orderStatusDate }},
				EXP: {{ order.meta.expanded }}
				S: {{ order.meta.sort }}
				C: {{ order.customerId }}
				layoutList: {{ this.layoutList }}
				ds: {{ this.order.meta?.dropship }}
			</div>
			<b style="flex-grow:1;">&nbsp;</b>



			<Circle fileName="w3_user_white" v-if="this.order?.customerId || this.order?.meta?.dropship" size="25px"
				color="--grey-6" padding="20%" style="margin-right:5px;"
				title="Order är en dropship-order och kommer skickas direkt till slutkund" />




			<div class="badge" style="margin-right:5px;background:var(--grey-6);padding:5px;text-align:center;width:30px;">{{
				this.order?.orderRowList?.length }}</div>

			<div class="order-status " :class="'order-status_' + this.order?.orderStatus?.status"
				style="height:100%;padding:5px;">{{
				order.orderStatus.label }}</div>


		</div>

		<div v-if="order.meta.expanded"> <!-- expanderad order -->

			<!-- debug order-info -->
			<div class="debug" v-if="this.debug && !this">
				version: {{ order.version }} edited: {{ this.order?.meta?.edited }} - {{ this.order?.orderId
				}}
			</div>

			<div style="background:transparent;border:5px solid var(--grey-4);"> <!-- border på expanderade ordern -->

				<div v-if="this.order?.canBeEdited" style=""> <!-- editerbar -->

					<!-- order -->
					<div style="background:var(--grey-2);padding:10px;">

						<div style="background:var(--grey-4);padding:10px;">
							<div class="flexcenter">

								<Icon icon="reload" :class="order.meta.updating ? 'spinning' : ''"
									style="height:25px;width:25px;margin-right:5px;" @click="this.getOrder()" />
								<h3>Order {{ this.order.orderId }}</h3>


								<b style="flex-grow:1;">&nbsp;</b>

								<Button v-if="this.currentOrderId != this.order?.orderId" label="Välj denna order"
									@click.stop="this.orderSelected()" style="margin-top:0px;" />

								<Button v-if="this.currentOrderId == this.order?.orderId" label="Vald order" style="margin-top:0px;"
									class="grey" />

								<Button label="Radera order" class="error" @click="deleteOrder()" style="" />

							</div>

						</div>

						<!-- order-information -->
						<div style="background:var(--grey-4);padding:10px;margin-top:0px;">
							<div class="flexcenter" style="margin-bottom:10px;">

								<b style="flex-grow:1;">Orderinformation</b>

							</div>


							<div v-if="this.order && this.order.canBeEdited">

								<div v-if="this.order.comment && this.order.comment.length > 2"
									style="background:var(--grey-2);padding:10px;border-radius: 5px;margin-top:10px;margin-bottom:10px;">
									<b style="font-size:80%;">Kommentar från BoOve</b><br />
									{{ this.order.comment }}
								</div>

								<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="Kontaktperson">
									<input type="text" placeholder="Kontaktperson" v-model="this.order.contactPerson"
										@keydown="order.meta.edited = true" style="padding:5px;" />
									<img src="@/assets/w3_button_close_light.png" @click="this.order.contactPerson = '' ">
								</div>

								<div class="form textField" style="max-width:300px;margin-bottom:10px;" title="Ert referensnummer">
									<input type="text" placeholder="Ert referensnummer" v-model="this.order.localId"
										@keydown="order.meta.edited = true" style="padding:5px;" />
									<img src="@/assets/w3_button_close_light.png" @click="this.order.localId = ''">
								</div>

								<div class="form textarea" title="Meddelande till BoOve">
									<textarea v-model="this.order.text" @keydown="order.meta.edited = true"
										placeholder="Meddelande till BoOve"></textarea>
								</div>



								<div class="flexcenter">
									<Button label="Spara orderinformation" :class="this.order.meta?.edited ? '' : 'grey'"
										@click="updateOrder()" style="margin-top:5px;margin-bottom:10px;" />
									<b style="flex-grow:1;">&nbsp;</b>

								</div>

							</div>
						</div>

						<!-- customer -->
						<div v-if="this.order.canBeEdited" style="margin-top:10px;background:var(--grey-4);padding:10px;">

							<div class="debug" v-if="this.debug && !this">dropship: {{ this.order?.meta?.dropship }}</div>

							<div class="flexcenter">
								<Button label="Skicka till återförsäljaren"
									:iconLeft="this.dropship || this.customer ? 'w3_circle_light.png' : 'w3_button_check_white.png' "
									@click="this.shipToAF()" :class="this.dropship || this.customer ? 'grey' : '' " />

								<Button label="Skicka direkt till slutkund" @click="this.shipToCustomer()"
									:class="this.dropship || this.customer ? '' : 'grey'"
									:iconLeft="this.dropship || this.customer ? 'w3_button_check_white.png' : 'w3_circle_light.png'" />
								<div v-if="this.dropship && !this.customer" class="flexcenter" style="flex-grow:1;">

									<div class="form textField" style="max-width:300px;flex-grow:1;" title="E-post till kund">
										<input type="text" placeholder="E-post" v-model="this.customerEmail"
											style="padding:5px;width:100%;" />
										<img src="@/assets/w3_button_close_light.png" @click="this.customerEmail = ''">
									</div>

									<Button label="Fortsätt" style="margin-left:5px;" @click="this.findCustomer()"
										:class="this.validCustomerEmail ? '' : 'grey'" />
								</div>
							</div>



							<div v-if="this.showNoCustomerMessage" class="link" @click="this.showNoCustomerMessage = false"
								style="background: var(--bg-error);padding:5px;color:white;margin-top:5px;border-radius:5px;">Du har
								valt
								att
								skicka direkt
								till kund men du har inte anvgivit någon kund. Ange kundens e-post ovan och klicka på Fortsätt</div>

							<div v-if="this.customer" style="margin-top:10px;background:var(--grey-2);padding:10px;">
								<b>Kundinformation för dropship</b>

								<div class="debug" v-if="!this && this.debug" style="margin-top:0px;">ID {{ this.customer.customerId }},
									version: {{
									this.customer.version }}, meta.edited: {{
									this.customer.meta.edited }}</div>

								<table style="width:100%; ">

									<tr>
										<td>
											<div class="form textField" style="max-width:300px;flex-grow:1;"
												title="Kundnummer hos återförsäljaren">
												<input type="text" placeholder="Kundnummer hos återförsäljaren"
													v-model="this.customer.companyCustomerNo" style="padding:5px;width:100%;" />
												<img src="@/assets/w3_button_close_light.png" @click="this.customer.companyCustomerNo = ''">
											</div>
										</td>
									</tr>


									<tr>
										<td>
											<div class="form textField" style="max-width:300px;flex-grow:1;" title="E-post">
												<input type="text" placeholder="E-post" v-model="this.customer.email"
													style="padding:5px;width:100%;" />
												<img src="@/assets/w3_button_close_light.png" @click="this.customer.email = ''">
											</div>
										</td>
									</tr>

									<tr>
										<td class="flexcenter">

											<div class="form textField" style="max-width:300px;flex-grow:1;" title="Förnamn">
												<input type="text" placeholder="Förnamn" v-model="this.customer.firstname"
													style="padding:5px;width:100%;" />
												<img src="@/assets/w3_button_close_light.png" @click="this.customer.firstname = ''">
											</div>
											<div class="form textField" style="max-width:300px;flex-grow:1;" title="Efternamn">
												<input type="text" placeholder="Efternamn" v-model="this.customer.lastname"
													style="padding:5px;width:100%;" />
												<img src="@/assets/w3_button_close_light.png" @click="this.customer.lastname = ''">
											</div>
										</td>
									</tr>

									<tr>
										<td>
											<div class="form textField" style="max-width:300px;flex-grow:1;" title="Gatuadress">
												<input type="text" placeholder="Gatuadress" v-model="this.customer.street"
													style="padding:5px;width:100%;" />
												<img src="@/assets/w3_button_close_light.png" @click="this.customer.street = ''">
											</div>
										</td>
									</tr>

									<tr>
										<td class="flexcenter">

											<div class="form textField" style="max-width:120px;flex-grow:1;" title="Postnummer">
												<input type="text" placeholder="Postnummer" v-model="this.customer.postcode"
													style="padding:5px;width:100%;" />
												<img src="@/assets/w3_button_close_light.png" @click="this.customer.postcode = ''">
											</div>
											<div class="form textField" style="max-width:300px;flex-grow:1;" title="Stad">
												<input type="text" placeholder="Stad" v-model="this.customer.city"
													style="padding:5px;width:100%;" />
												<img src="@/assets/w3_button_close_light.png" @click="this.customer.city = ''">
											</div>
										</td>
									</tr>

									<tr>
										<td>
											<div class="form textField" style="max-width:300px;flex-grow:1;" title="Telefonnummer">
												<input type="text" placeholder="Telefonnummer" v-model="this.customer.phone"
													style="padding:5px;width:100%;" />
												<img src="@/assets/w3_button_close_light.png" @click="this.customer.phone = ''">
											</div>
										</td>
									</tr>

									<tr>
										<td>
											<input type="checkbox" value="true" v-model="this.customer.dataApproved" /> Kunden godkänner att
											personuppgifterna sparas
										</td>
									</tr>
									<tr>
										<td>
											<input type="checkbox" value="true" v-model="this.customer.temporary" /> Kunden vill att
											personuppgifterna
											raderas efter leverans.
										</td>
									</tr>
									<tr>
										<td>
											<div class="flexcenter">
												<Button label="Spara uppdaterad kund" :class="this.customer?.meta.edited ? '' : 'grey' "
													style="margin-left:5px;" @click="this.updateCustomer()" />
												<b style="flex-grow:1;">&nbsp;</b>
												<Button label="Ta bort kund från order" class="warning" style="margin-left:5px;"
													@click="this.removeCustomer()" />
											</div>
										</td>
									</tr>


								</table>
							</div>
							<div v-if="!this.customer && this.order?.customerId > 0">
								Hittade ingen kund för id: {{ this.order.customerId }}

							</div>




						</div>

						<!-- order information -->
						<div v-if="!order.canBeEdited">
							<div class="textField">
								Kontaktperson: {{ order.contactPerson }}
							</div>
							<div class="textField">
								Märkning: {{ order.localId }}
							</div>
							<div class="textField">
								Kommentar: {{ order.comment }}
							</div>
							<div class="textField">
								OrderText: {{ order.text }}<br />
							</div>
						</div>

						<div v-if="order.canBeEdited" style="background: var(--grey-4);padding:10px;margin-top:10px;">
							<div :class="this.showApproveOrder ? 'showApproveOrderTrue' : 'showApproveOrderFalse' "
								class="approveOrder">
								<input type="checkbox" v-model="this.approved"><b @click="this.approved = !this.approved"
									class="link">Ordern
									är kontrollerad och redo att skickas</b>
							</div>

							<div style="padding:5px;">
								<input type="checkbox" v-model="this.createNew">Skapa automatiskt en ny order
							</div>

							<div style="padding:5px;" v-if="order.meta.previousOrderId">
								<input type="checkbox" v-model="this.gotoPrevious">Återgå till tidigare order: <b>{{
									order.meta.previousOrderId }}</b>
							</div>


							<Button label="Skicka order" :class="this.approved ? '' : 'grey' " @click="this.sendOrder()"
								style="margin-top:5px;margin-bottom:10px;" />




							<Button v-if="this.debug" class="debug" label="Debug" @click="this.showDebug = !this.showDebug" />
							<div class="debug" v-if="showDebug">
								<pre>
						{{ this.order }}
						</pre>
							</div>

						</div>

						<div style="margin-top:10px;">

							<h3>Lägg till produkter</h3>

							<!-- lägg till produkt / importera fil -->
							<div style="padding:0px;align-items: stretch;" class="flexcenter">

								<!-- lägg till produkt -->
								<div class="" style="background:var(--grey-3);padding:10px;width:40%;">
									<b>Lägg till en produkt</b>
									<div class="flexcenter" style="margin-top:5px;">

										<div class="form textField" style="max-width:200px;flex-grow:1;" title="Artikelnummer">
											<input type="text" placeholder="Artikelnummer" v-model="this.importArtnr"
												style="padding:5px;width:100%;" />
											<img src="@/assets/w3_button_close_light.png" @click="this.importArtnr = ''">
										</div>

										<div class="form textField" style="max-width:70px;flex-grow:1;" title="Antal">
											<input type="text" placeholder="Antal" v-model="this.importQuantity"
												style="padding:5px;width:100%;" />
											<img src="@/assets/w3_button_close_light.png" @click="this.importQuantity = ''">
										</div>



										<Button label="Lägg till" @click="this.importProduct()" :class="this.vaildImport ? '' : 'grey'" />
									</div>
									<div class="link flexcenter" @click="this.importErrorMessage = null" v-if="this.importErrorMessage"
										style="background:var(--bg-error); padding:5px;color:white;margin-bottom:5px;border-radius: 5px;margin-top:5px;">
										<b style="flex-grow:1;">{{ this.importErrorMessage }}</b>
										<Circle fileName="w3_close_white" padding="25%" size="25px" color="darkred" hover="darkred" />

									</div>

								</div>

								<!-- importera fil -->
								<div style="background:var(--grey-3);width:calc(60% - 10px);padding:10px;background:var(--grey-3);">

									<!-- header -->
									<div class="flexcenter link" @click="this.showImportFile = !this.showImportFile">
										<Circle :fileName="this.showImportFile ? 'w3_chevron_up_white' : 'w3_chevron_down_white'"
											size="20px" padding="20%" color="--grey-6" hover="black" />
										<b style="margin-left:5px;flex-grow:1;">Importera fil / lägg till många produkter</b>
										<Circle fileName="w3_question_white" size="20px" padding="20%" color="--grey-6"
											@click.stop="this.showInformation = !this.showInformation; !this.showImportFile ? this.showImportFile = true : null" />
									</div>

									<!-- help/infomation -->
									<div v-if="this.showInformation" style="background:var(--grey-4);padding:5px;margin-top:5px;">
										<b>Textfil (.txt)</b> <br />
										Formatet på datat ska vara: artikelnummer;antal;
										Varje produkt ska vara på en egen rad.
										<br /><br />
										<b>Excel (.xls eller .xlsx)</b><br />
										Artikelnummer ska stå i första kolumnen och antalet i andra kolumnen.
										<div class="flexcenter" style="gap:0px;">
											<div style="padding:5px;border:2px solid darkgrey;">Artikelnummer</div>
											<div style="padding:5px;border:2px solid darkgrey;border-left:0px;">Antal</div>
										</div>

										<Button label="Stäng" style="margin-top:5px;" @click="this.showInformation = false" />
									</div>

									<!-- bläddra / importera-->
									<div v-if="this.showImportFile">
										<div class=" flexcenter" style="margin-top:5px;flex-direction: column;align-items:stretch;">

											<input type="file" ref="doc" value="" @change="readFile()"
												style="background:var(--grey-4);padding:5px;width:calc(100% - 10px);border-radius:5px;"
												accept=".xls,.xlsx,.txt,.csv" />




											<!-- importera filinnehåll -->
											<div class="height:500px;" style="margin-top:5px;height:200px;width:calc(100% - 10px);">

												<textarea v-model="this.importFileContent"
													style="height:calc(100% - 10px);width:100%;outline: none;"></textarea>
											</div>

											<!-- importfile result-->
											<div v-if="this.importFileResultList && this.importFileResultList.length > 0"
												style="margin-top:5px;padding:10px;background:var(--grey-4);">

												<div style="margin-bottom:5px;" class="flexcenter">
													<b style="flex-grow:1;">Filen innehåller {{ this.importFileResultList.length == 1 ? 'ett fel'
														:
														this.importFileResultList.length + ' fel' }}, rätta och försök på nytt.</b>
													<Button label="Rensa" class="grey" @click="this.importFileResultList = []" />
												</div>

												<div style="max-height:100px;overflow:scroll;">
													<div v-for="(importFileContentResultRow, index) in this.importFileResultList" :key="index"
														style="background:var(--bg-error); padding:5px;color:white;margin-bottom:5px;border-radius: 5px;">
														{{ importFileContentResultRow }}

													</div>
												</div>
											</div>


										</div>
										<Button label="Import" @click="this.importFile()" style="margin-top:5px;"
											:class="this.validImportFile ? '' : 'grey'" />
									</div>
								</div>

							</div>
							<!-- import result -->
							<div v-if="this.importRowList && this.importRowList?.length > 0"
								style="background:var(--grey-3);width:100%;padding:10px;margin-top:5px;">

								<div class="flexcenter">
									<b style="flex-grow:1;">Resultat av import / lägg till </b>
									<Circle v-if="this.importing" fileName="w3_spinner_dark" size="25px" style="background:transparent;"
										:spinning="true" />
									<div class="flexcenter" style="background:var(--grey-6);padding:5px;border-radius: 5px;color:white;">




										{{ this.importCountModel?.completed }} / {{ this.importCountModel?.total }}
									</div>
								</div>

								<!-- import resultat header -->
								<div style=" max-height:300px;overflow:scroll;margin-top:5px;">
									<table style="width:100%;" id="resultTable">
										<thead>
											<tr>
												<th style="">&nbsp;</th>
												<th>Artnr</th>
												<th>Antal</th>
												<th>Totalt</th>
												<th>Resultat</th>
											</tr>
										</thead>

										<tbody v-for="(importRow, index) in this.importRowList" :key="index"
											style="background-color: var(--grey-4);margin-bottom:5px;padding:5px;">

											<tr>
												<td>
													<Circle fileName="w3_spinner_white" v-if="importRow.state == 'IMPORTING'" :spinning="true"
														color="--grey-5" />
													<div style="width:50px;" v-if="importRow.importResult?.status" class="result"
														:class="'result_' + importRow.importResult?.status">{{ importRow.importResult?.status }}
													</div>
												</td>
												<td>
													{{ this.formatArtnr(importRow.artnr) }}
												</td>
												<td>
													{{ importRow.quantity }}
												</td>
												<td>
													{{ importRow.importResult?.quantity }}
												</td>
												<td :title="this.debug ? importRow.importResult?.debug : ''">

													<b v-if="importRow.importResult?.productName">{{ importRow.importResult?.productName
														}}<br /></b>
													<!-- message FAIL -->
													<div v-if="importRow.importResult?.message && importRow.importResult?.status == 'FAIL'"
														style="font-size:100%;">
														{{ importRow.importResult?.message }}
													</div>

													<!-- message OK -->
													<div v-if="importRow.importResult?.message && importRow.importResult?.status != 'FAIL'"
														style="background:var(--grey-5);padding:3px;border-radius: 5px;font-size:80%;margin-top:5px;">
														{{ importRow.importResult?.message }}
													</div>

													<div class="flexcenter" style="margin-top:5px;">
														<div v-if="importRow.importResult?.noInStock" class="noInStock"
															:class="'noInStock_' + importRow.importResult?.noInStock"
															:title="importRow.importResult?.noInStock" style="font-size:80%;margin-right:5px;">
															{{ this.noInStockLabel(importRow.importResult?.noInStock) }}
														</div>
														<b style="font-weight:bold;font-size:80%;"> {{ importRow.importResult?.deliveryTime
															}}</b>
													</div>

												</td>



											</tr>
											<tr v-if="!this && this.debug">
												<td colspan="5">{{ importRow.importResult }}</td>
											</tr>
										</tbody>

									</table>

								</div>
								<div v-if="this.importCompleteMessage" id="import-complete" style="">
									<div class="flexcenter">
										<Circle fileName="w3_check_white" padding="20%" color="--bg-ok" size="25px" />
										<b style="margin-left:5px;flex-grow:1;">Import klar</b>
										<div class="flexcenter badge" style="background: var(--bg-ok);">Lyckades <div
												class="semi50 badge-count" style="">{{
												this.importCompleteMessage?.countImported }}</div>
										</div>
										<div class="flexcenter badge" v-if="this.importCompleteMessage?.countFail > 0"
											style="background: var(--bg-error);">Misslyckades <div class="semi50 badge-count" style="">{{
												this.importCompleteMessage?.countFail }}</div>
										</div>
										<Button label="Stäng" @click="this.resetImport()" />
									</div>

								</div>

							</div>
						</div>



					</div>

				</div><!-- editerbar order klar -->
				<!-- inskickad order -->
				<div v-if="!this.order?.canBeEdited">


					<!-- order -->
					<div style="background:var(--grey-2);padding:10px;" id="sent-order">

						<div style="background:var(--grey-4);padding:10px;">
							<div class="flexcenter" style="margin-bottom:5px;">

								<Icon icon="reload" :class="order.meta.updating ? 'spinning' : ''"
									style="height:25px;width:25px;margin-right:5px;" @click="this.getOrder()" />
								<h3>Order {{ this.order.orderId }}</h3>

							</div>
							<div style="margin-top:10px;background:var(--grey-2);padding:10px;text-align:center;">
								<h3 style="margin-bottom:5px;">Ordern är inskickad och kan inte editeras</h3>


							</div>

							<div id="order-information" style="margin-top:10px;background:var(--grey-2);padding:10px;">
								<b>Orderinformation </b>
								<div v-if="this.order?.comment" class="label" style="">
									<b>Kommentar från BoOve</b><br />
									<div class="value">{{ this.order.comment }}</div>
								</div>

								<div class="label" style="">
									<b>Kontaktperson</b><br />
									<div class="value">{{ this.order.contactPerson }}</div>
								</div>

								<div class="label" style="">
									<b>Ert referensnummer</b><br />
									<div class="value">{{ this.order.localId }}</div>
								</div>

								<div class="label" style="">
									<b>Meddelande till BoOve</b><br />
									<div class="value">{{ this.order.notes }}</div>
								</div>

								<div style="margin-top:10px;">
									<b>Orderstatus</b>
									<div class="label" style="">
										<b>Beställningsdatum</b><br />
										<div class="value">{{ this.sendDate }}</div>
									</div>

									<div class="label" style="">
										<b>Mottagningsdatum</b><br />
										<div class="value">{{ this.recivedDate }}</div>
									</div>

								</div>

							</div>

							<div>


							</div>

							<div v-if="this.customer" id="customer-information"
								style="margin-top:10px;background:var(--grey-2);padding:10px;">

								<b>Kundinformation för dropship</b>

								<div class="label" style="">
									<b>Kundens kundnummer hos er</b><br />
									<div class="value">{{ this.customer?.companyCustomerNo }}</div>
								</div>

								<div class="label" style="">
									<b>E-post</b><br />
									<div class="value">{{ this.customer?.email }}</div>
								</div>

								<div class="flexcenter" style="gap:10px;">
									<div class="label" style="">
										<b>Förnamn</b><br />
										<div class="value">{{ this.customer?.firstname }}</div>
									</div>
									<div class="label" style="">
										<b>Efternamn</b><br />
										<div class="value">{{ this.customer?.lastname }}</div>
									</div>
								</div>

								<div class="label" style="">
									<b>Gatuadress</b><br />
									<div class="value">{{ this.customer?.street }}</div>
								</div>

								<div class="flexcenter" style="gap:10px;">
									<div class="label" style="">
										<b>Postnummer</b><br />
										<div class="value">{{ this.customer?.postcode }}</div>
									</div>
									<div class="label" style="">
										<b>Stad</b><br />
										<div class="value">{{ this.customer?.city }}</div>
									</div>
								</div>

								<div class="label" style="">
									<b>Telefonnummer</b><br />
									<div class="value">{{ this.customer?.phone }}</div>
								</div>

								<div style="margin-top:10px;">
									<b v-if="this.customer?.temporary" style="color:red;">Kunden vill att uppgifterna raderas efter att
										ordern är skickad</b>
									<b v-if="!this.customer?.temporary">Kunden godkänner att uppgifterna sparas efter att ordern är
										skickad</b>
								</div>
								<div style="margin-top:10px;">
									<b v-if="this.customer?.dataApproved">Kunden har godkänt att personuppgifterna sparas </b>
									<b v-if="!this.customer?.dataApproved">Kunden har inte godkänt att personuppgifterna sparas </b>


								</div>


							</div>
						</div>

					</div>

				</div>

				<!-- orderRader -->
				<div style="margin-top:10px;padding:10px;">
					<h3>Orderrader</h3>
					<table id="orderRowList" style=" width:100%;">
						<thead>
							<tr>
								<th v-if="order.canBeEdited" style="width:40px;">
									--
								</th>
								<th v-if="this.debug" style="width:100px;">OrderRowId</th>
								<th style="width:100px;">Artnr</th>
								<th style="width:50px;">Antal</th>
								<th>Benämning</th>
								<th title="Lagersaldo när ordern skickades in">Lager</th>
								<th v-if="this.debug">Lager nu</th>
								<th>Pris</th>
								<th v-if="order.canBeEdited" style="width:30px;">&nbsp;</th>
							</tr>
						</thead>


						<OrderRow v-for="(orderRow) in order.orderRowList" :key="orderRow.orderRowId" :orderRow="orderRow"
							:orderId="orderId" />
					</table>
				</div>
			</div> <!-- expanded -->
		</div>
	</div>
</template>

<script>
import { userMixin } from '../../mixins/userMixin';
import { productMixin } from '../../mixins/productMixin';
import { formatMixin } from '../../mixins/formatMixin';
import { PRODUCT_STORE_GETTER } from '../../store/product-store';
import { USER_STORE_ACTION, USER_STORE_COMMIT } from '../../store/user-store';
import OrderRow from './OrderRow.vue';

import * as XLSX from 'xlsx'

export default {
	name: "Order",
	components: {
		OrderRow
	},
	mixins: [userMixin, formatMixin, productMixin],
	props: {
		orderId: Number,
		layoutList: {
			value: Boolean,
			default: false
		}
	},
	data() {
		return {
			createNew: true,
			gotoPrevious: false,
			showDebug: false,
			customerEmail: null,
			currentCustomerData: null,
			approved: false,
			showNoCustomerMessage: false,
			showApproveOrder: false,
			importArtnr: null,
			importQuantity: null, 
			file: null,
			importFileContent: "",
			importFileResultList: [],
			importErrorMessage: null,
			importRowList: [],
			importing: false,
			importResult: [],
			importCompleteMessage: null,
			limit: 0,
			maxLimit: 500,
			showImportFile: false,
			showInformation: false
		}
	},
	computed: {
		order() {
			const order = this.$store.state.userStore.data.userModel.orderList[this.orderId];
			return order;
		},
		customer(){
			if (this.order?.customerId > 0){
				const customer = this.$store.state.userStore.data.userModel?.customerList[this.order?.customerId];
				return customer;
			}

			return null;

		},
		customerData(){

			if (!this.customer){
				return null;
			}

			var data = ""
			data = data + this.customer?.firstname
			data = data + this.customer?.lastname
			data = data + this.customer?.email
			data = data + this.customer?.phone
			data = data + this.customer?.companyCustomerNo
			data = data + this.customer?.street
			data = data + this.customer?.postcode
			data = data + this.customer?.city
			data = data + this.customer?.country
			data = data + this.customer?.dataApproved
			data = data + this.customer?.temporary

			return data;
		},
		dropship(){
			return this.order?.meta?.dropship == true
		},
		validCustomerEmail(){

			if (!this.customerEmail){
				return false;
			}

			if (!this.customerEmail.includes("@")){
				return false;
			}

			if (!this.customerEmail.includes(".")){
				return false;
			}

			return true;
		},
		productList() {
			return this.$store.getters[PRODUCT_STORE_GETTER.PRODUCT_LIST]
			
		},
		importQue(){
			return this.importRowList?.filter(importRow => importRow.state == 'START')
		},
		importCountModel(){
			const total = this.importRowList?.length;
			const completed = total - this.importQue?.length
			return {completed: completed, total: total} 
		},

		orderRowLengthLabel(){
			
			if (this.order?.orderRowList?.length == 0){
				return "Inga produkter"
			}

			if (this.order?.orderRowList?.length == 1) {
				return "En produkt"
			}

			if (this.order?.orderRowList?.length > 1) {
				return this.order?.orderRowList?.length + " produkter"
			}

			return "";

		},
		vaildImport(){

			
			if (!this.importArtnr || this.importArtnr.length < 5){
				return false;
			}

			const quantity = parseInt(this.importQuantity)

			if (!quantity || quantity <= 0 || quantity > 1000) {
				return false;
			}

			return true;

		},
		validImportFile(){

				if (!this.importFileContent || this.importFileContent.length < 5){
					return false;
				}

				return true;

		},
		sendDate(){
			const date = this.order?.orderStatusList?.find(orderStatus => orderStatus.status == 20)
			return date?.date;
		},
		recivedDate(){
			const date = this.order?.orderStatusList?.find(orderStatus => orderStatus.status == 30)
			if(date){
				return date?.date;
			}

			return "--"
		}
		
	},
	watch:{
		customerData: function (customerData, oldCustomerData) {
			console.log("FP: watcher: customerData", customerData);

			console.log("FP: watcher: oldCustomerData", oldCustomerData);

			if(this.customer && oldCustomerData != null){
				this.customer.meta.edited = true
			}

			if (this.currentCustomerData == null){
				this.currentCustomerData = customerData;
			}
			
		},
		approved:function(approved){
			if (approved){
				this.showApproveOrder = false
			}
		},
		importArtnr:function(){
			this.importErrorMessage = null
		},
		importQuantity:function(){
			this.importErrorMessage = null
		},
		orderId:function(){

			if (this.order?.meta?.previousOrderId){
				this.createNew = false;
				this.gotoPrevious = true;
			}else{
				this.createNew = true;
				this.gotoPrevious = false;
			}
				


			

		}
		

	},
	methods: {


		readFile(){

			this.file = this.$refs.doc.files[0];


			const reader = new FileReader()
			reader.onload = (res) => {
				this.importFileContent = res.target.result;
				//const text = (e.target.result).trim()
				//console.log(text)
				//alert(text)
				//this.setState({ importData: text })



			};

			const readerXLS = new FileReader()

			readerXLS.onload = (evt) => { // evt = on_file_select event
				/* Parse data */
				const bstr = evt.target.result;
				const wb = XLSX.read(bstr, { type: 'binary' });
				/* Get first worksheet */
				const wsname = wb.SheetNames[0];
				const ws = wb.Sheets[wsname];
				/* Convert array of arrays */
				//const data = XLSX.utils.sheet_to_csv(ws, {header:1});

				const data = XLSX.utils.sheet_to_json(ws, { header: 1 });

				var text = "";

				data.forEach(row => {
					if(row[0] && row[1]){
						text = text + row[0] + ";" + row[1] + ";\n";
					}
				})

				
				//text = text.trim();
				//this.setState({ importData: text })
				this.importFileContent = text;
			};
				
			if (this.file?.size > 1000000) { // 1000000
				this.importFileResultList.push("Filen är för stor.");

			} else if (this.file?.type == "text/plain") {
				reader.readAsText(this.file)

			} else if (this.file?.type == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
				readerXLS.readAsArrayBuffer(this.file);

			} else if (this.file?.type == "application/vnd.ms-excel") {
				readerXLS.readAsArrayBuffer(this.file);

			} else {
				this.importFileResultList.push("Filen är av fel filtyp (" + this.file.type + "), endast: .txt .xls och .xlsx är giltiga");
			}


		},
		

		importProduct(){

			this.resetImport();

			

			const artnr = this.importArtnr

			if (!artnr || artnr.length < 5){
				this.importErrorMessage = "Felaktigt artikelnummer";
				return;
			}

			const quantity = parseInt(this.importQuantity)

			if (!quantity || quantity <= 0 || quantity > 1000) {
				this.importErrorMessage = "Felaktigt antal";
				return;
			}

			


			
			this.importRowList.push({ index: 1, artnr: artnr, quantity: quantity, state: "START", importResult: null })
			this.importArtnrNext();

		

		},

		resetImport(){
			this.importFileResultList = [];
			this.importRowList = [];
			this.limit = 0;
		},
		importFile(){


			this.resetImport()

			let index = 0;
			this.importCompleteMessage = null;

			this.importFileContent.split("\n")?.forEach(importRow => {

				if (importRow && importRow != ""){

					index++;

					const artnr = importRow.split(";")[0];
					var quantity = importRow.split(";")[1];

					if (!quantity > 0){
						quantity = 0;
					}
			
					var error = false;

					if (!importRow.includes(";")){
						this.importFileResultList.push("Rad: " + index + ": Felaktigt format, semikolon saknas. ");
						error = true;
					}

					if (!error && !artnr || artnr.length < 5){
						this.importFileResultList.push("Rad: " + index + ": Felaktigt artikelnummer: " + artnr);
						error = true;
					}

					if (!error && !quantity > 0) {
						this.importFileResultList.push("Rad: " + index + ": Felaktigt antal");
						error = true
					}

					if (!error && quantity > 1000) {
						this.importFileResultList.push("Rad: " + index + ": Felaktigt antal");
						error = true
					}

					if (!error){
						this.importRowList.push({ index: index, artnr: artnr, quantity: quantity, state: "START", importResult: null})
					}
					


				}
				
			})

			if (this.importFileResultList.length == 0) {
				this.importArtnrNext();
			} else {
				this.importRowList = [];
			}
			//importRowList: [],

			// kopiera innehåll och flytta till listan, kör formattering, kolla artnr och antal. 
			// kör den första
		},

		importArtnrNext(){
			const importRow = this.importRowList.find(importRow => importRow.state == "START")
			if (!importRow){
				this.importComplete();
				
				return;
			}

			if (!this.order.canBeEdited) {
				alert("Ordern är redan beställd");
				return;
			}

			this.importing = true

			this.importCompleteMessage = null
			

			importRow.state = "IMPORTING"

			// importera 
			var data = { orderId: this.orderId, post: { artnr: importRow.artnr, quantity: importRow.quantity } }
			this.$store.dispatch({ type: USER_STORE_ACTION.IMPORT_PRODUCT_TO_ORDER, data: data }).then((result) => {

				console.log('FP: importArtnrNext result: ', result);

				importRow.state = "IMPORTED"

				if (result.status == "OK"){
					
					if (result.importResult) {
						importRow.importResult = result.importResult

						if (importRow.importResult?.status == "FAIL"){
							importRow.state = "FAIL"
						}

					}

				}else{
					importRow.state = "FAIL"
				}

			}).finally(() => {
				
				const importRow = this.importRowList.find(importRow => importRow.state == "START")
				if (importRow){

					this.limit = this.limit + 1 

					if (this.limit < this.maxLimit){
						this.importArtnrNext(); 
					}else{
						alert("För många produkter att importera, försök igen");
					}

					
				}else{
					this.importComplete();
				}

			});

		},

		importComplete(){
			const countImported = this.importRowList.filter(importRow => importRow.state == "IMPORTED")?.length;
			const countFail = this.importRowList.filter(importRow => importRow.state == "FAIL")?.length;

			

			this.importCompleteMessage = {countImported: countImported, countFail: countFail}
			this.importing = false;


		},

		shipToAF(){
			
			if (this.customer && window.confirm("Vill du ta bort kunden från ordern och skicka produkterna direkt till er vanliga leveransadress?")){
				
				this.order.meta.updating = true
			

				this.$store.dispatch({ type: USER_STORE_ACTION.REMOVE_CUSTOMER, data: { orderId: this.orderId } }).then((result) => {

					console.log('FP: order shipToAF result: ', result);
					
					if (this.order?.meta) {
						this.order.meta.dropship = false
						
					}

				}).finally(() => {
					this.order.meta.updating = false
					//this.customerData = null FP: 2026 ändrade till nedan
					this.currentCustomerData = null;


				})
			}else{
				this.order.meta.dropship = false
			}
		},
		shipToCustomer(){
		
			this.order.meta.dropship = true
		},

		
		orderSelected() {

			if (!this.order.canBeEdited) {
				alert("Ordern är redan beställd");
				return;
			}

			this.order.meta.expanded = true

			this.$store.commit(USER_STORE_COMMIT.SET_CURRENT_ORDER_ID, this.order.orderId)
		},
		toggleExpanded() {
			this.order.meta.expanded = !this.order.meta.expanded
		},
		sendOrder() {


			if (this.dropship && !this.customer){
				console.log('FP: sendOrder dropship: ', this.dropship);
				

				alert("Du har valt att skicka direkt till kund men du har inte anvgivit någon kund. Ange kundens e-post ovan och klicka på Fortsätt");
				this.showNoCustomerMessage = true;
				return;
			}

			if (!this.order.canBeEdited) {
				alert("Ordern är redan beställd");
				return;
			}

			if (!this.approved) {
				alert("Markera att ordern är kontrollerad och är redo att skickas.")
				this.showApproveOrder = true;
				return;
			}

			this.edited = false
			
			this.order.meta.updating = true


			this.$store.dispatch({ type: USER_STORE_ACTION.UPDATE_ORDER, data: { order: this.order, send: true } }).finally(() => {
				this.order.meta.updating = false
				this.order.meta.dropship = false

				if (this.createNew) {
					this.$store.dispatch({ type: USER_STORE_ACTION.CREATE_ORDER, data: {} })

				}

				if (this.gotoPrevious && this.order.meta?.previousOrderId){
					this.$store.commit(USER_STORE_COMMIT.SET_CURRENT_ORDER_ID, this.order.meta?.previousOrderId);
				}

			})


		},

		findCustomer() {

			if (!this.validCustomerEmail) {
				alert("Felaktigt format på e-post");
				return;
			}

			if (!this.order.canBeEdited) {
				alert("Ordern är redan beställd");
				return;
			}
		
			const customerEmail = this.customerEmail;

			this.showNoCustomerMessage = false;

			

			this.order.meta.updating = true
			this.currentCustomerData = null // sätter till null så inte watchen ska triggas. 

			this.$store.dispatch({ type: USER_STORE_ACTION.FIND_CUSTOMER, data: { orderId: this.orderId, search: customerEmail } }).finally(() => {
				this.order.meta.updating = false
				

			})
		},
		updateCustomer() {



			if (!this.customer) {
				alert("Kan inte spara kund");
				return;
			}

			if (!this.order.canBeEdited) {
				alert("Ordern är redan beställd");
				return;
			}

			if (!this.customer.dataApproved) {
				alert("Kan inte spara kund.\nKunden behöver godkänna att personuppgifterna sparas.");
				return;
			}

			this.order.meta.updating = true

			this.$store.dispatch({ type: USER_STORE_ACTION.UPDATE_CUSTOMER, data: { orderId: this.orderId, customer: this.customer } }).finally(() => {
				this.order.meta.updating = false


			})
		},

		removeCustomer() {


			if (!window.confirm("Om du tar bort kunden kommer produkterna skickas till er vanliga leveransadress, vill du ta bort kunden?")){
				return;
			}
			
			if (!this.order.canBeEdited) {
				alert("Ordern är redan beställd");
				return;
			}

			this.order.meta.updating = true

			this.$store.dispatch({ type: USER_STORE_ACTION.REMOVE_CUSTOMER, data: { orderId: this.orderId } }).finally(() => {
				this.order.meta.updating = false


			})
		},


		updateOrder() {

			if (!this.order.canBeEdited) {
				alert("Ordern är beställd och kan inte uppdateras");
				return;
			}


			this.edited = false
			this.order.meta.updating = true

			this.$store.dispatch({ type: USER_STORE_ACTION.UPDATE_ORDER, data: { order: this.order } }).finally(() => {
				this.order.meta.updating = false


			})
		},
		deleteOrder() {

			if (!this.order.canBeEdited) {
				alert("Ordern är beställd och kan inte raderas");
				return;
			}

			if (!window.confirm("Vill du radera ordern?")) {
				return;
			}

			this.edited = false

			this.order.meta.updating = true

			this.$store.dispatch({ type: USER_STORE_ACTION.DELETE_ORDER, data: { orderId: this.order.orderId } }).finally(() => {
				//this.order.meta.updating = false
			})
		},

		getOrder(){

			console.log('FP: order getOrder: ', this.order);
			

			this.order.meta.updating = true

			this.$store.dispatch({ type: USER_STORE_ACTION.GET_ORDER, data: { orderId: this.order.orderId } }).finally(() => {
				this.order.meta.updating = false
			})
		}




	},
	
};
</script>

<style scoped>
div.approveOrder.showApproveOrderTrue{
	background: lightblue;
	padding:5px;
}

div.approveOrder.showApproveOrderFalse {
	background: transparent;
	padding: 5px;
}
table tr td {
	padding:5px;
}

table tr td div.result {
	padding:5px;
	text-align:center;
	color:white;
	border-radius: 5px;
	font-weight: bold;
}

table tr td div.result.result_OK{
	background: var(--bg-ok);
}

table tr td div.result.result_FAIL{
	background: var(--bg-error);
}

table tr td div.noInStock{
		padding: 5px;
			text-align: center;
			color: white;
			border-radius: 5px;
			font-weight: bold;
}

table tr td div.noInStock.noInStock_OUT_OF_STOCK{
	background: var(--bg-error);
}

table tr td div.noInStock.noInStock_LOW_STOCK {
	background: var(--bg-warning);
}

table tr td div.noInStock.noInStock_IN_STOCK {
	background: var(--bg-ok);
}

div table#resultTable thead tr th{
	background:var(--grey-5);
	padding:5px; 

}

div.order-status{
	border-radius: 5px;
	color:white;
	font-size:100%;
	font-weight: bold;
	width:100px;
	text-align:center;
}
div.order-status.order-status_10{
	background:var(--bg-warning); 
	margin-right:10px;
}

div.order-status.order-status_20 {
	background: var(--bg-message);
	margin-right:10px;
}

div.order-status.order-status_30 {
	background: var(--bg-ok);
		margin-right: 10px;
}
div#import-complete{
	background: var(--grey-6);
		padding: 5px;
		margin-top: 10px;
		border-radius: 5px;
		color: white;
}

div#import-complete div.badge{
	
		border-radius: 5px;
		padding-left: 10px;
		padding-right: 5px;
		font-weight: bold;
}

div#import-complete div.badge div.badge-count {
	padding: 3px;
	margin-left: 5px;
	font-size: 90%;
	font-weight: bold;
	border-radius: 3px;
}

table#orderRowList thead tr th{
	background:var(--grey-4);
	padding:10px;
}

div#order-information div.label,
div#customer-information div.label {
	margin-top: 5px;
}

div#order-information div.label b,
div#customer-information div.label b{
	color:grey;
	font-size:80%;
}


</style>